---
title: Application Assembly using Web Services
slug: application-assembly-web-services
type: paper
status: published
featured: true
summary: Software application realization and deployment through reusable assets and assembly — service composition as an engineering problem, not a slide.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2002-01-01"
lastReviewedAt: "2026-09-18"
audiences:
  - product-developer
themes:
  - platform-architecture
  - product-lines
sourceUrl: https://ucla.academia.edu/JayvanZyl
originalAuthor: Jay van Zyl
sourceRelationship: academic record listed on Academia.edu profile
rightsStatus: outbound-only
seoDescription: 2002 paper by Jay van Zyl on application assembly using web services and software assets.
canonicalPath: /research/application-assembly-web-services
authors:
  - Jay van Zyl
year: 2002
venue: Working paper
publicationType: article
citation: "van Zyl, J. (2002). Application Assembly using Web Services: Software application realization and deployment through the use of software assets and assembly."
researchTheme: application-assembly
recordUrl: https://ucla.academia.edu/JayvanZyl
---

Takeaway: assembly of certifiable assets is the same instinct as generating a baseline from a validated model. Profile listing: [Academia.edu](https://ucla.academia.edu/JayvanZyl). Specific paper URL not isolated beyond the profile at last review.
